import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    accordion: {
      text: 'A beneficial owner holds more than 25% of voting rights or capital or has control over the company.',
      title: 'What is a beneficial owner?',
    },
    buttons: {
      cta: 'Start my declaration',
      skip: 'Declare later',
    },
    description: `We are legally required to collect information on all beneficial owners of {companyName}.`,
    heading: 'Declare beneficial owners',
    steps: [
      {
        description:
          'All beneficial owners are mentioned in your articles of association, INPI notices, or beneficial owners register.',
        title: 'Get the list of beneficial owners',
      },
      {
        description:
          'Provide their full names and the control they exercise over the company.',
        title: 'Complete their information',
      },
      {
        description: 'We will contact them to verify their identities.',
        title: 'Provide their emails',
      },
    ],
  },
  fr: {
    accordion: {
      text: "Un bénéficiaire effectif détient plus de 25 % des droits de vote ou du capital, ou dispose d'un pouvoir de contrôle sur l'entreprise.",
      title: 'Qu’est ce qu’un bénéficiaire effectif ?',
    },
    buttons: {
      cta: 'Démarrer ma déclaration',
      skip: 'Déclarer plus tard',
    },
    description: `Nous devons légalement recueillir les informations de tous les bénéficiaires effectifs de {companyName}.`,
    heading: 'Déclarez les bénéficiaires effectifs',
    steps: [
      {
        description:
          'Tous les bénéficiaires effectifs sont mentionnés sur vos statuts, avis INPI ou registre des bénéficiaires effectifs.',
        title: 'Munissez-vous de la liste des bénéficiaires effectifs',
      },
      {
        description:
          'Indiquez leurs noms complets et le contrôle qu’ils exercent sur la société.',
        title: 'Complétez leurs informations',
      },
      {
        description: 'Nous les contacterons pour vérifier leur identité.',
        title: 'Renseignez leurs e-mails',
      },
    ],
  },
} as const);
